<template>
    <v-card @click="$emit('click', value)" flat :class="['option-card', {'selected': active}]">
        <v-card-text :class="['title pb-2']">
            {{label}}
        </v-card-text>
        <v-card-text class="title pt-1">
            <v-icon class="icon" size="25">{{icon}}</v-icon>
        </v-card-text>
    </v-card>
</template>

<script>
    export default{
        props:{
            icon:{
                type: String,
                default: 'fa-user'
            },
            value:{
                type: String,
                required: true
            },
            label:{
                type: String,
                required: true
            },
            active:{
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

    .option-card{
        border-radius: 0 !important;
        transition: .2s all;
        border-bottom: 4px solid transparent;
    }

    .option-card:hover{
        cursor: pointer;
        transform: scale(1.02);
    }

    .option-card:hover .title,
    .option-card:hover .icon{
        color: #000000;
    }

    .option-card .title{
        font-weight: 300;
    }

    .option-card.selected{
        border-bottom: 4px solid var(--v-primary-base);
        box-shadow: none !important;
        transform: scale(.98);
    }

    .option-card.selected .title,
    .option-card.selected .icon{
        color: var(--v-primary-base) !important;
    }

</style>